/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemBlobPreconditionFailed } from './ProblemBlobPreconditionFailed';
import { ProblemPreconditionFailed } from './ProblemPreconditionFailed';
import { ProblemResourcePreconditionFailed } from './ProblemResourcePreconditionFailed';

export const PreconditionFailedProblems: core.serialization.Schema<
    serializers.PreconditionFailedProblems.Raw,
    Truvity.PreconditionFailedProblems
> = core.serialization
    .union('type', {
        '/precondition-failed': ProblemPreconditionFailed,
        '/precondition-failed/blob': ProblemBlobPreconditionFailed,
        '/precondition-failed/resource': ProblemResourcePreconditionFailed,
    })
    .transform<Truvity.PreconditionFailedProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace PreconditionFailedProblems {
    export type Raw =
        | PreconditionFailedProblems.PreconditionFailed
        | PreconditionFailedProblems.PreconditionFailedBlob
        | PreconditionFailedProblems.PreconditionFailedResource;

    export interface PreconditionFailed extends ProblemPreconditionFailed.Raw {
        type: '/precondition-failed';
    }

    export interface PreconditionFailedBlob extends ProblemBlobPreconditionFailed.Raw {
        type: '/precondition-failed/blob';
    }

    export interface PreconditionFailedResource extends ProblemResourcePreconditionFailed.Raw {
        type: '/precondition-failed/resource';
    }
}
